var nb = {
  "Add Quantity Breaks to your product page": "Legg til mengderabatter på produktsiden din",
  "Add Upsell.com to your ": "Legg til Upsell.com på ",
  "Add to cart click": "Klikk på Legg i handlekurv",
  "All time": "Hele tiden",
  "and select": "og velg",
  "button": "knappen",
  "Cart drawer page": "Handlevognskuff-side",
  "Cart page": "Handlekurv-side",
  "Check status": "Sjekk status",
  "Checkout page": "Kasse-side",
  "Checkout click": "Klikk på Kasse",
  "Click": "Klikk på",
  "Click on": "Klikk på",
  "Click the": "Klikk på",
  "Custom slot": "Egendefinert plass",
  "Custom slots": "Egendefinerte plasser",
  "Custom Slots": "Egendefinerte plasser",
  "Enable in theme editor": "Aktiver i temaeditoren",
  "contact support.": "kontakt support.",
  "from the right sidebar": "fra høyre sidepanel",
  "Go to App Embeds": "Gå til app-innebygginger",
  "Go to your Cart drawer page": "Gå til Handlevognskuff-siden din",
  "Go to your Cart page": "Gå til Handlekurv-siden din",
  "Go to your Checkout page": "Gå til Kasse-siden din",
  "Go to your Order status page": "Gå til Ordrestatus-siden din",
  "Go to your Post purchase page": "Gå til Post-kjøp siden din",
  "Go to your Product page": "Gå til Produktsiden din",
  "Go to your Thank you page": "Gå til Takk-siden din",
  "items": "varer",
  "in the left sidebar": "i venstre sidepanel",
  "Last 12 months": "Siste 12 måneder",
  "Last 30 days": "Siste 30 dager",
  "Last 365 days": "Siste 365 dager",
  "Last 7 days": "Siste 7 dager",
  "Last 90 days": "Siste 90 dager",
  "Last month": "Forrige måned",
  "Last year": "I fjor",
  "Make sure": "Sørg for at",
  "Need assistance? Contact our support team for help.": "Trenger du hjelp? Kontakt vårt supportteam.",
  "Order status page": "Ordrestatus-side",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Appen vår gjennomgår for tiden litt magi for å forbedre opplevelsen din.",
  "Post purchase page": "Post-kjøp side",
  "Product page": "Produktside",
  "Save": "Lagre",
  "Scroll to the bottom and select": "Rull til bunnen og velg",
  "Select": "Velg",
  "Success. Please continue.": "Suksess. Vennligst fortsett.",
  "Thank you page": "Takk-side",
  "The Upsell.com team.": "Upsell.com-teamet.",
  "The Upsell.com widget is not placed on ": "Upsell.com-widgeten er ikke plassert på ",
  ". Please follow the steps above or ": ". Vennligst følg trinnene ovenfor eller ",
  "Today": "I dag",
  "toggle is on": "bryteren er på",
  "Total": "Totalt",
  "under": "under",
  "We apologize for any inconvenience caused,": "Vi beklager ulempe dette medfører,",
  "We apologize for any inconvenience caused.": "Vi beklager ulempe dette medfører.",
  "We'll be done in a few minutes!": "Vi er ferdige om noen minutter!",
  "We're improving our services!": "Vi forbedrer tjenestene våre!",
  "Widget already added": "Widget allerede lagt til",
  "Yesterday": "I går",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Du aktiverte widgeten i nettbutikken din, men lagret den ikke i Upsell-editoren",
  "You placed the widget on the ": "Du plasserte widgeten på ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", men du lagret den ikke i Shopify-editoren. Gå tilbake til ",
  " and save the changes.": " og lagre endringene."
};

export { nb as default };
//# sourceMappingURL=nb.json.js.map
